/**
 * About section with the architecture figure.
 *
 * Converted verbatim from `public/index.html:125-193`. The figure opens the
 * lightbox on click, as it did at `:571-577`.
 */
import architecture from './assets/architecture.png';

interface Props {
  onOpenArchitecture: (src: string) => void;
}

const AboutSection = ({ onOpenArchitecture }: Props) => (
  <section id="about" className="about-section">
    <div className="section-header">
      <h2 className="section-title">About LungChat</h2>
      <p className="section-subtitle">
        Democratizing access to complex lung biology analysis
      </p>
    </div>

    <div className="about-content">
      <div className="about-text">
        <p className="about-description">
          LungChat democratizes access to advanced multiomics analysis for lung
          biology research. Simply ask questions in natural language—LungChat
          automatically decomposes complex queries into subtasks and
          orchestrates parallel analysis across multiple specialized agents.
          Seamlessly integrate single-cell RNA-seq data from 470+ donors,
          spatial transcriptomics, pathway enrichment from 120+ databases,
          direction-aware drug connectivity analysis from 143K+ perturbation
          profiles, and literature synthesis—all without writing a single line
          of code.
        </p>
        <p className="about-description" style={{ marginTop: '1.5rem' }}>
          Through integrated multi-omics reasoning, LungChat jointly interprets
          findings across modalities and scales—connecting cellular signatures
          to spatial niches, pathways to therapeutic targets, and discoveries to
          published literature. The result: actionable scientific insights with
          full reproducibility.
        </p>
        <div className="about-features">
          <div className="about-feature-item">
            <svg
              className="feature-check"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span>Publication-ready Visualizations</span>
          </div>
          <div className="about-feature-item">
            <svg
              className="feature-check"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span>Therapeutic Target Predictions</span>
          </div>
          <div className="about-feature-item">
            <svg
              className="feature-check"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span>Structured Scientific Reports</span>
          </div>
          <div className="about-feature-item">
            <svg
              className="feature-check"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span>Testable Biological Hypotheses</span>
          </div>
          <div className="about-feature-item">
            <svg
              className="feature-check"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span>Reproducible Analytical Workflows</span>
          </div>
        </div>
      </div>
      <div className="about-architecture">
        <img
          src={architecture}
          alt="LungChat Architecture"
          className="architecture-img"
          onClick={() => onOpenArchitecture(architecture)}
        />
      </div>
    </div>
  </section>
);

export default AboutSection;
